import { UserItem } from '@/types/userItem';

/**
 * Returns true when the only image we can show for this item is a stock photo
 * (no user-uploaded image). These items are blocked from being listed for sale —
 * buyers want proof the seller actually has the card in hand.
 */
export function hasOnlyStockPhoto(_item: Pick<UserItem, 'images' | 'stock_image_url' | 'proof_images'>): boolean {
  // Real-photo requirement removed — sellers can list with stock photos.
  return false;
}


/** Short reusable copy explaining the rule + the timestamp trust nudge. */
export const STOCK_PHOTO_BLOCK_TITLE = 'Add a real photo to list this';
export const STOCK_PHOTO_BLOCK_DESC =
  'Stock photos are fine for tracking, but buyers expect a real photo of the actual item. Tip: include a Proof-of-Possession photo! Add a small note with your username and date in your photo to build buyer trust and rank your listing higher.';

/** One-liner for inline hints near photo controls. */
export const TIMESTAMP_TIP =
  'Tip: include a Proof-of-Possession photo! Add a small note with your username and date in your photo to build buyer trust and rank your listing higher.';
